import { SxStyle } from '@aibees/shared/theme';

export const summary: SxStyle = {
  width: 'fit-content',
  paddingX: '0 !important',
};

export const details: SxStyle = {
  paddingX: '0 !important',
};
